// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__m3dVN","center":"style_center__Mi8cH"};